import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  signs: [],
  sign: {
    id: 0,
    pk: "",
    instance: "",
    belongingId: 0,
    representativeId: 0,
    digitalsignstatusId: 0,
    razon: "",
    comment:"",
    entity: "",
    isIntern: false,
  },
  onboardingStartUr:"",
  signValidation: {
    isValid: true,
    pk: {
      isValid: true,
      errorMessage: "El campo pk no debe estar vacio",
    },
    instance: {
      isValid: true,
      errorMessage: "El campo instancia no debe estar vacio",
    },
    belongingId: {
      isValid: true,
      errorMessage: "El campo perteneciente no debe estar vacio",
    },
    representativeId: {
      isValid: true,
      errorMessage: "El campo representante no debe estar vacio",
    },
    digitalsignstatusId: {
      isValid: true,
      errorMessage: "El campo status no debe estar vacio",
    },
    razon: {
      isValid: true,
      errorMessage: "El campo razon no debe estar vacio",
    },
    comment: {
      isValid: true,
      errorMessage: "El campo razon no debe estar vacio",
    },
    entity: {
      isValid: true,
      errorMessage: "El campo entidad no debe estar vacio",
    }
  },
};

const signSlice = createSlice({
  name: "sign",
  initialState,
  reducers: {
    restartState(state) {
      state.sign = {};
      state.signs = [];
    },
    setSigns(state, actions) {
      state.signs = actions.payload.signs;
      state.sign = {};
    },
    setOnboardingUrl(state, actions) {
      state.signs = [];
      state.sign = {};
      state.onboardingStartUr = actions.payload.onboardingStartUr;
    },
    setSign(state, actions) {
      state.sign = actions.payload.sign;
      state.signs = [];
    },
    modifyPropertyValue(state, actions) {
      state.sign[actions.payload.id] = actions.payload.value;
    },
    setSignValidation(state, actions) {
      state.signValidation = {
        pk: {
          ...state.signValidation.pk,
          isValid: actions.payload.pk !== "",
        },
        instance: {
          ...state.signValidation.instance,
          isValid: actions.payload.instance !== "",
        },
        belongingId: {
          ...state.signValidation.belongingId,
          isValid: actions.payload.belongingId !== "",
        },
        representativeId: {
          ...state.signValidation.representativeId,
          isValid: actions.payload.representativeId !== "",
        },
        digitalsignstatusId: {
          ...state.signValidation.digitalsignstatusId,
          isValid: actions.payload.digitalsignstatusId !== "",
        },
        razon: {
          ...state.signValidation.razon,
          isValid: actions.payload.razon !== "",
        },
        comment: {
          ...state.signValidation.comment,
          isValid: actions.payload.comment !== "",
        },
        entity: {
          ...state.signValidation.entity,
          isValid: actions.payload.entity !== "",
        }
      };
      state.signValidation.isValid =
        state.signValidation.city.isValid;
    },
    setFieldValid(state, actions) {
      state.signValidation[actions.payload.id].isValid = actions.payload.value;
    },
  },
});

export const signActions = signSlice.actions;
export default signSlice;
